import React from "react";
import styles from "./CartCompletePage.module.css";
import { CartInformationCompleted, CartStep, CartTotal } from "components/Cart";
import { Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { fetchPaymentRequest } from "redux/ActionCreators/PaymentActionCreator";

const CartCompletePage = () => {
  const dispatch = useDispatch();

  const handlePaymentCart = (carts, informationCart) => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      addressDetail,
      city,
      district,
      ward,
      paymentMethod,
    } = informationCart;

    dispatch(
      fetchPaymentRequest(
        firstName,
        lastName,
        addressDetail,
        phoneNumber,
        city.name,
        district.name,
        ward.name,
        paymentMethod,
        carts,
        email
      )
    );
  };

  return (
    <section className={styles.section}>
      <div className={styles.item}>
        <CartStep />
      </div>
      <div className={styles.item}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <CartTotal />
          </Grid>
          <Grid item xs={12} sm={9}>
            <CartInformationCompleted handelDataSubmit={handlePaymentCart} />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default CartCompletePage;
